import { Box, Grid, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import PlainModal from '../../../components/modal/PlainModal'
import {
  getInfluencerSteps,
  onboardContentNicheStepList,
  onboardInfluencerStepTypes,
} from '../../../helpers/onboard-helper'
import useAppUtilities from '../../../hooks/useAppUtilities'
import { useAppSelector } from '../../../store'
import {
  selectIsInfluencerOnboardModalOpen,
  selectOnboardContentNicheDetail,
  selectOnboardDescribeYourselfDetail,
  selectOnboardSocialChannelsDetail,
  setIsInfluencerOnboardModalOpen,
} from '../../../store/influencer/contentCreator'
import { IStepper } from '../../../types'
import {
  OnboardContentNicheMethods,
  OnboardDescribeYourselfMethods,
  OnboardSocialChannelMethods,
} from '../../../types/contentCreatorTypes'
import OnboardStepper from '../../eater/onboardPages/OnboardSteppar'
import {
  OnboardMainContainer,
  OnboardSidebarLogoImg,
} from '../../eater/onboardPages/styled/OnboardContainer.styled'
import ContentNicheStep from './components/ContentNicheStep'
import DescribeYourselfStep from './components/DescribeYourselfStep'
import OnboardFooterButton from './components/OnboardFooterButton'
import OnboardHeader from './components/OnboardHeader'
import SocialChannelsStep from './components/SocialChannelsStep'
import { infoLog } from '../../../utils/log-helper'

const Onboard: React.FC = () => {
  const isInfluencerOnboardModalOpen = useAppSelector(
    selectIsInfluencerOnboardModalOpen,
  )
  const discretionYourself = useAppSelector(selectOnboardDescribeYourselfDetail)
  const contentNiche = useAppSelector(selectOnboardContentNicheDetail)
  const socialChannels = useAppSelector(selectOnboardSocialChannelsDetail)
  const { dispatch } = useAppUtilities()
  const [steps] = useState<IStepper[]>(getInfluencerSteps)
  const [activeStep, setActiveStep] = useState(
    onboardInfluencerStepTypes.DESCRIBE_YOURSELF,
  )
  const describeYourselfRef = useRef<OnboardDescribeYourselfMethods>(null)
  const contentNicheRef = useRef<OnboardContentNicheMethods>(null)
  const socialChannelsRef = useRef<OnboardSocialChannelMethods>(null)
  const [isValidData, setIsValidData] = useState<boolean>(false)

  const onCloseInfluencerOnboardModal = (): void => {
    dispatch(setIsInfluencerOnboardModalOpen(false))
  }

  const onBack = (): void => {
    if (activeStep === onboardInfluencerStepTypes.SELECT_CONTENT_NICHE) {
      setActiveStep(onboardInfluencerStepTypes.ADD_SOCIAL_CHANNELS)
    } else if (activeStep === onboardInfluencerStepTypes.ADD_SOCIAL_CHANNELS) {
      setActiveStep(onboardInfluencerStepTypes.DESCRIBE_YOURSELF)
    } else if (activeStep === onboardInfluencerStepTypes.DESCRIBE_YOURSELF) {
      // TODO: Add logic here
      infoLog('back')
    }
  }

  const onNext = async (): Promise<void> => {
    if (activeStep === onboardInfluencerStepTypes.DESCRIBE_YOURSELF) {
      describeYourselfRef.current?.getPayload()

      setActiveStep(onboardInfluencerStepTypes.ADD_SOCIAL_CHANNELS)
    } else if (activeStep === onboardInfluencerStepTypes.ADD_SOCIAL_CHANNELS) {
      socialChannelsRef.current?.getPayload()

      setActiveStep(onboardInfluencerStepTypes.SELECT_CONTENT_NICHE)
    } else if (activeStep === onboardInfluencerStepTypes.SELECT_CONTENT_NICHE) {
      await contentNicheRef.current?.getPayload()

      // TODO: Add logic here
      infoLog('done', {
        discretionYourself,
        contentNiche,
        socialChannels,
      })
    }
  }

  return (
    <Box>
      <PlainModal
        open={isInfluencerOnboardModalOpen}
        handleClose={onCloseInfluencerOnboardModal}
        modelWidth="800px"
        borderNone
      >
        <Box p={1} height={'550px'}>
          <OnboardMainContainer>
            <Grid
              item
              md={4}
              lg={4}
              border={1}
              p={3}
              bgcolor="primary.main"
              borderRadius="16px"
            >
              <Box>
                <OnboardSidebarLogoImg />
                <Typography variant="h3" color="background.paper">
                  Influencer
                </Typography>
                <Typography variant="h3" mb={4} color="background.paper">
                  Profile Setup
                </Typography>

                <OnboardStepper activeStep={activeStep} steps={steps} />
              </Box>
            </Grid>
            <Grid item md={8} p={2}>
              <Box
                width="100%"
                height="100%"
                display="flex"
                alignItems="end"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box width="100%">
                  <OnboardHeader title="Describe Yourself and Your Content" />
                  {activeStep ===
                    onboardInfluencerStepTypes.DESCRIBE_YOURSELF && (
                    <DescribeYourselfStep
                      ref={describeYourselfRef}
                      setIsValidData={setIsValidData}
                    />
                  )}
                  {activeStep ===
                    onboardInfluencerStepTypes.ADD_SOCIAL_CHANNELS && (
                    <SocialChannelsStep
                      ref={socialChannelsRef}
                      setIsValidData={setIsValidData}
                    />
                  )}
                  {activeStep ===
                    onboardInfluencerStepTypes.SELECT_CONTENT_NICHE && (
                    <ContentNicheStep
                      editMode
                      items={onboardContentNicheStepList}
                      ref={contentNicheRef}
                    />
                  )}
                </Box>
                <OnboardFooterButton
                  onBack={onBack}
                  onNext={() => {
                    void onNext()
                  }}
                  nextBtnLabel={
                    activeStep ===
                    onboardInfluencerStepTypes.SELECT_CONTENT_NICHE
                      ? 'Apply'
                      : 'Next'
                  }
                  isValid={isValidData}
                />
              </Box>
            </Grid>
          </OnboardMainContainer>
        </Box>
      </PlainModal>
    </Box>
  )
}

export default Onboard
